import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Styles = styled.div`

`;

const FooterSection = () => { 
  const { t } = useTranslation(); // LANGUAGE  

    return (
        <Styles>
            {/* === FOOTER SECTION ==== */}
            <footer>
                <div className="footer-section animate__animated animate__fadeInUp">

                    <div className="container"> 

                        <div className="row">
                            <div className="col">
                                <ul className="list-group list-group-horizontal one-row-mobile">
                                    <li className="list-group-item list-group-border"><a href="https://www.ttsh.com.sg/About-TTSH/TTSH-News/Pages/default.aspx" title="News" target="_self">
                                        {/* News */}
                                        {t('text.21')} 
                                        </a></li>
                                    <li className="list-group-item list-group-border"><a href="https://www.ttsh.com.sg/About-TTSH/Careers/Pages/default.aspx" title="Careers" target="_self">
                                        {/* Careers */}
                                        {t('text.22')} 
                                        </a></li>
                                    <li className="list-group-item list-group-border"><a href="https://www.ttsh.com.sg/About-TTSH/Gallery/Pages/default.aspx" title="Gallery" target="_self">
                                        {/* Gallery */}
                                        {t('text.23')} 
                                        </a></li>
                                    <li className="list-group-item list-group-border"><a href="https://www.ttsh.com.sg/Pages/sitemap.aspx" title="Sitemap" target="_self">
                                        {/* Sitemap */}
                                        {t('text.24')} 
                                    </a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <ul className="list-group list-group-horizontal float-right one-row-mobile">
                                    <li className="list-group-item list-group-border"><a className="is-inline-block-desktop-only" href="https://www.ttsh.com.sg/Pages/Contact-Us.aspx" title="Contact Us" target="_self">
                                        {/* Contact Us */}
                                        {t('text.25')} 
                                        </a></li>
                                    <li className="list-group-item list-group-border"><a className="is-inline-block-desktop-only" href="https://www.ttsh.com.sg/Pages/feedback.aspx" title="Feedback" target="_self">
                                        {/* Feedback */}
                                        {t('text.26')} 
                                        </a></li>
                                    <li className="list-group-item list-group-border"><a className="is-inline-block-desktop-only" href="https://www.ttsh.com.sg/About-TTSH/TTSH-Events/Pages/default.aspx" title="Events" target="_self">
                                        {/* Events */}
                                        {t('text.27')} 
                                        </a></li>

                                    <li className="list-group-item list-group-border mobile-center-icon">
                                        <a className="icon-sec mobile-icon-space" href="https://www.facebook.com/TanTockSengHospital/" title="TTSH official Facebook" rel="noreferrer"><i className="bi bi-facebook icon-spacing"></i></a>
                                        <a className="icon-sec mobile-icon-space" href="https://www.instagram.com/tantocksenghospital/" title="TTSH official Instagram" rel="noreferrer"><i className="bi bi-instagram icon-spacing"></i></a>
                                        <a className="icon-sec mobile-icon-space" href="https://www.youtube.com/user/TanTockSengHospital" title="TTSH official YouTube" rel="noreferrer"><i className="bi bi-youtube icon-spacing"></i></a>
                                        <a className="icon-sec mobile-icon-space" href="https://twitter.com/ttsh/" title="TTSH official Twitter" rel="noreferrer"><i className="bi bi-twitter icon-spacing"></i></a>
                                        <a className="icon-sec mobile-icon-space" href="https://www.linkedin.com/company/tan-tock-seng-hospital/?originalSubdomain=sg" title="TTSH official LinkedIn" rel="noreferrer"><i className="bi bi-linkedin icon-spacing"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <hr />

                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="list-group justify-content-center list-group-horizontal one-row-mobile">
                                    <li className="list-group-item list-group-border">
                                            {/* className="show-ext" */}
                                        <a href="https://www.ttsh.com.sg/Patients-and-Visitors/TTSH-Health-Library/Pages/default.aspx" target="_self">
                                            {/* TTSH ​​Health Library  */}
                                            {t('text.28')} 
                                            </a>
                                    </li>
                                    <li className="list-group-item list-group-border">
                                        <a href="https://www.ttsh.com.sg/Patients-and-Visitors/Medical-Services/Pages/default.aspx" target="_self">
                                            {/*  Find Specialties and Services */}
                                            {t('text.29')} 
                                            </a></li>
                                    <li className="list-group-item list-group-border">
                                        <a href="https://www.ttsh.com.sg/Patients-and-Visitors/Pages/Find-Clinics-and-Facilities.aspx" target="_self">
                                            {/* Find Clinics and Facilities */}
                                            {t('text.30')} 
                                            </a></li>
                                    <li className="list-group-item list-group-border">
                                        <a href="https://www.ttsh.com.sg/Patients-and-Visitors/Pages/Find-Specialist.aspx" target="_self">
                                            {/* Find a Specialist */}
                                            {t('text.31')} 
                                            </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-sm-12 copyright-section">
                                <p className="text-align-center mobile-align-copyright"> &copy; 2021 Tan Tock Seng Hospital. All Rights Reserved. </p>
                                <p className="text-align-center mobile-align-copyright"> Last Updated on 12 September 2021</p>
                            </div>

                        </div>


                    </div>

                </div>
            </footer>
            {/* === END FOOTER SECTION ==== */}

        </Styles>
    );
};

export default FooterSection;



